module.exports = __webpack_public_path__ + "static/media/sf-yogi.85b214dd.jpg";